import { faCheck, faCopy } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ActionIcon, CopyButton, Tooltip } from '@mantine/core';
import { useTranslation } from 'react-i18next';

const TRANS_PATH = 'COMPANY_LINKS.CONTACT_CARD';

type ContactCardCopyButtonPropsType = {
  value: string;
};

export const ContactCardCopyButton: React.FC<
  ContactCardCopyButtonPropsType
> = ({ value }) => {
  const { t } = useTranslation('personDetailsGeneral');

  return (
    <CopyButton value={value}>
      {({ copied, copy }) => {
        const label = copied
          ? t(`${TRANS_PATH}.COPIED`)
          : t(`${TRANS_PATH}.COPY`);

        return (
          <Tooltip label={label}>
            <ActionIcon
              variant="subtle"
              color="gray"
              size="sm"
              onClick={copy}
              aria-label={label}
            >
              <FontAwesomeIcon icon={copied ? faCheck : faCopy} />
            </ActionIcon>
          </Tooltip>
        );
      }}
    </CopyButton>
  );
};
